import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as contactActions from '../../actions/contact';
import { Link } from 'react-router-dom';
import Header from '../Header';

import Recaptcha from 'react-recaptcha';

class Contact extends React.Component {
  state = {
    name: '',
    email: '',
    message: '',
    human: false,
    errors: [],
    sent: false
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  contact = e => {
    e.preventDefault();
    let errors = [];
    if (this.state.email === '') {
      errors.push('Email address is required');
    }

    if (errors.length < 1 && this.state.human) {
      return this.props._contact.sendContact(this.state.email, this.state.message, this.state.name)
        .then(res => this.setState({ sent: true }))
        .catch(err => this.setState({ sent: true }));
    }

    this.setState({ errors: errors });
  }

  verifyCallback() {
    this.setState({ human: true });
  }

  render() {
    return <section>
      <Header {...this.props} />
      <div className="container has-text-centered">
       <section className="section">
          <div className="container">
            <h1 className="title is-3" style={{ marginBottom: '3rem' }}>Contact Us</h1>
            <div className="columns">
              <div className="column has-text-left">
                <p className="subtitle">Engaged Practice Home Office:</p>
                <p>10 Garland Road</p>
                <p>Lincoln, MA 01773</p>
              </div>
              <div className="column">
                {this.state.errors.map((e, i) => <div key={i} className="notification is-warning">{e}</div>)}
                {this.state.sent && <div className="notification is-success">Message sent!<br/> Someone will be in touch soon!</div>}
                <form onSubmit={this.contact}>
                  <div className="field has-text-left">
                    <label className="label" htmlFor="name">Name</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="name"
                        onChange={this.onChange}
                        value={this.state.name} />
                    </div>
                  </div>

                  <div className="field has-text-left">
                    <label className="label" htmlFor="email">Email</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="email"
                        onChange={this.onChange}
                        value={this.state.email} />
                    </div>
                  </div>

                  <div className="field has-text-left">
                    <label className="label" htmlFor="message">Message</label>
                    <div className="control">
                      <textarea value={this.state.message} name="message" onChange={this.onChange} className="textarea"></textarea>
                    </div>
                  </div>

                  <div className="field has-text-centered">
                    <Recaptcha
                      sitekey="6LdhemsUAAAAAGxM8pC33LfWbA_Csi7FaJN10rqa"
                      render="explicit"
                      size="normal"
                      verifyCallback={this.verifyCallback.bind(this)}
                    />
                  </div>

                  <button type="submit" className="button is-info" disabled={!this.state.human}>Contact</button>
                </form>
              </div>
              <div className="column"></div>
            </div>
          </div>
        </section>
      </div>
    </section>;
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    _contact: bindActionCreators(contactActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);



// WEBPACK FOOTER //
// ./src/components/pages/Contact.js